import React from 'react';
import CommonIssueTypeFilter from '@atlassian/jira-filters/src/ui/filters/issue-type/index.tsx';
import { ErrorFlag } from '@atlassian/jira-issue-error-flag';
import { fireUIAnalytics, useAnalyticsEvents } from '@atlassian/jira-product-analytics-bridge';
import type { IssueTypeId } from '@atlassian/jira-shared-types/src/general.tsx';
import { useIssueTypeIdsFilter } from '../../../controllers/top-filter';
import { useIssueTypes } from '../../../services/get-issue-types';
import messages from './messages';

const IssueTypeFilter = () => {
	const { data: issueTypes, error, loading } = useIssueTypes({ excludeEpic: true });
	const { createAnalyticsEvent } = useAnalyticsEvents();
	const [selectedIssueTypes, actions] = useIssueTypeIdsFilter();

	if (loading) {
		return null;
	}

	if (error) {
		return (
			<ErrorFlag
				error={error}
				title={messages.issueTypeFilterErrorFlagTitle}
				description={messages.issueTypeFilterErrorFlagDescription}
			/>
		);
	}

	return (
		<CommonIssueTypeFilter
			// @ts-expect-error - TS2322 - Type 'IssueType[] | undefined' is not assignable to type 'IssueType[]'.
			issueTypes={issueTypes}
			selectedIssueTypes={selectedIssueTypes}
			onChange={(ids: IssueTypeId[]) => {
				fireUIAnalytics(
					createAnalyticsEvent({
						action: 'toggled',
						actionSubject: 'deploymentsIssueTypeFilter',
					}),
				);
				actions.setIssueTypeIdsFilter(ids);
			}}
		/>
	);
};

export default IssueTypeFilter;
